module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jr4nbv/tc-custom/9781426884405.jpg?1709154772802",
      "alt": "This image is the cover for the book Deadly Kisses, The Francesca Cahill Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Deadly Kisses, The Francesca Cahill Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Gilded Age socialite-turned-sleuth must clear her fiancé of murder in the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author’s historical mystery romance series.")]), _c('br'), _c('br'), _vm._v("Called to the home of her fiancé’s former mistress late one night, Francesca Cahill finds her curiosity piqued. But upon arrival, she is shocked to find Daisy Jones’s bloodied body . . . and even more devastated when the evidence points to one suspect: her fiancé, Calder Hart."), _c('br'), _c('br'), _vm._v("Francesca refuses to believe that Calder is capable of such an act. Still, she is unable to shake her instinctive sense that Calder is lying about "), _c('i', [_vm._v("something")]), _vm._v(". The police are far less inclined to believe his innocence, and Calder is arrested for Daisy’s murder. But Francesca’s heart is not easily swayed—until a life-altering secret is exposed that could destroy their future together.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brenda Joyce\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Brenda Joyce is a New York Times bestselling author of more than 50 novels and novellas, including the popular and critically acclaimed de Warenne Dynasty Saga, a series of novels set in Regency and Victorian England. She lives on a ranch in Arizona with her dogs, broodmares and the year’s current crop of foals. If she isn’t on the back of a reining horse, she can be found madly at work in her office, penning her latest romance novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0